// extracted by mini-css-extract-plugin
export default {"containerInside":"CustomModal_containerInside__51Dom","agoraContainer":"CustomModal_agoraContainer__UJgDd","buttons":"CustomModal_buttons__RGFRt","alert":"CustomModal_alert__lS-lq"};